import { render } from "./CButton.vue?vue&type=template&id=e0862d3e&scoped=true&ts=true"
import script from "./CButton.vue?vue&type=script&lang=ts"
export * from "./CButton.vue?vue&type=script&lang=ts"

import "./CButton.vue?vue&type=style&index=0&id=e0862d3e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0862d3e"]])

export default __exports__